import { FC, useState } from 'react';
import loadable from '@loadable/component';
import {
  FavoriteToggleContext,
  FavoriteToggleContextType,
  FavoriteToggleButton,
  AdvertFavoriteBottomSheetHolder,
} from '#baseMenu/components';

const AdvertFavoriteBottomSheet = loadable(() => import('#advertFavorite/containers'), {
  resolveComponent: ({ AdvertFavoriteBottomSheet: Component }) => Component,
});

const FavoriteToggle: FC = () => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isLoadInProcess, setIsLoadInProcess] = useState<boolean>(false);

  const favoriteToggleContextValue: FavoriteToggleContextType = {
    AdvertFavoriteBottomSheet,
    isLoaded,
    setIsLoaded,
    isLoadInProcess,
    setIsLoadInProcess,
  };

  return (
    <FavoriteToggleContext value={favoriteToggleContextValue}>
      <FavoriteToggleButton />
      <AdvertFavoriteBottomSheetHolder />
    </FavoriteToggleContext>
  );
};

export { FavoriteToggle };
